export function txtNormalizeUrl(url) {
    // Vérifier si l'URL est vide ou null
    if (!url || typeof url !== 'string') {
        throw new Error('URL invalide ou vide');
    }

    // Nettoyer l'URL (supprimer les espaces)
    url = url.trim();

    // Si l'URL commence déjà par un protocole, la retourner telle quelle
    if (url.match(/^https?:\/\//i)) {
        return url;
    }

    // Si l'URL commence par //, ajouter https:
    if (url.startsWith('//')) {
        return 'https:' + url;
    }

    // Si l'URL commence par www., ajouter https://
    if (url.startsWith('www.')) {
        return 'https://' + url;
    }

    // Si l'URL contient un point et ressemble à un domaine, ajouter https://
    if (url.includes('.') && !url.includes('/') || url.match(/^[a-zA-Z0-9-]+\.[a-zA-Z]{2,}/)) {
        return 'https://' + url;
    }

    // Si l'URL commence par un nom de domaine sans www
    if (url.match(/^[a-zA-Z0-9-]+\.[a-zA-Z]{2,}/)) {
        return 'https://' + url;
    }

    // Pour les chemins relatifs ou autres cas, ajouter https://
    if (url.startsWith('/')) {
        throw new Error('Chemin relatif détecté - un domaine de base est requis');
    }

    // Cas par défaut : considérer comme un domaine et ajouter https://
    return 'https://' + url;
}